import { useQueries } from '@tanstack/react-query';

import { useMemo } from 'react';

import { usePasswordProtectedQueries } from '@app-velocity/modules/password-sharing';
import { TPrototypePartialDto } from '@app-velocity/av-api-v2';

const useFetchScenarioPartial = (shareToken: string | null) => {
  const { getSharedScenarioPartial } = usePasswordProtectedQueries();

  const fetchPartial = async (partialId: string) => {
    if (!shareToken) return;

    return await getSharedScenarioPartial(shareToken, partialId, 'report');
  };

  return fetchPartial;
};

export const useGetScenarioPartialsQuery = (
  shareToken: string,
  partialIds: string[]
) => {
  const fetchPartial = useFetchScenarioPartial(shareToken || '');

  const results = useQueries({
    queries: (partialIds || []).map((partialId) => ({
      queryKey: ['scenario-partial', shareToken, partialId],
      queryFn: async () => {
        if (!shareToken || !partialId) return;

        const data = fetchPartial(partialId);

        return data;
      },
    })),
  });

  const data = useMemo(
    () => results.map((r) => r.data).filter(Boolean) as TPrototypePartialDto[],
    [results]
  );

  return { data, isLoading: results.some(r => r.isPending) };
};
